import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { GalleryPersonlaProduct, GalleryProductService } from 'src/app/Services/Gallery-Products-Service/galleryproduct.service';

@Component({
    selector: 'app-view-gallery-product',
    templateUrl: './view-gallery-product.component.html',
    styleUrls: ['./view-gallery-product.component.css'],
    standalone: false
})
export class ViewGalleryProductComponent implements OnInit {
  public GalleryProduct: GalleryPersonlaProduct[] = []
  public galleryId!: string;
  public isGallery: boolean = false;
  public isLoading: boolean = true;
  public authConfig: AuthConfig = {};
  constructor(
    private GalleryProductService: GalleryProductService,
    private ngxSpinnerService: NgxSpinnerService,
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    
  ) { }

  ngOnInit(): void {
    this.getAllGalleryProduct()
  }

  private getAllGalleryProduct() {
    this.isLoading = true;
    this.ngxSpinnerService.show();
    this.GalleryProductService.getAllGalleryProduct().subscribe(
      (GalleryProduct) => {
        this.GalleryProduct = GalleryProduct;
        console.log('GalleryProduct', this.GalleryProduct);
        this.isLoading = false;
        this.ngxSpinnerService.hide();
      },
      (error) => {
        this.isLoading = false;
        this.handleRequestError(error);
      }
    );
  }
  
  private handleRequestError(error: any) {
    console.error(error);
    this.ngxSpinnerService.hide();
  }

  public oncreateGalleryProduct() {
    this.router.navigate(['gallery-product/create'])
  }

  public goToArtworkDetails(selectedProduct: GalleryPersonlaProduct) {
    this.router.navigate(['/gallery-products', selectedProduct.Id]);
  }
}